import { PixelFrontendClient } from '@propps-au/pixel-client'
import { SessionEventConfigs } from '@propps-au/pixel-event-configs'
import { ScriptEventConfigs } from './event-configs'

let client: PixelFrontendClient

export const getPixelClient = () => {
  if (!client) {
    client = new PixelFrontendClient({
      configs: {
        ...ScriptEventConfigs,
        ...SessionEventConfigs,
      },
      mailroom: {
        basePath: import.meta.env.VITE_PIXEL_MAILROOM_ENDPOINT as string,
      },
    })
  }
  return client
}
